module.exports = require('./lib/ReactS3');